import { createClientSharedComposable, getStore } from '@global-store/store'
import type {
  DeviceStore,
  DeviceType,
} from '@shared/global-store/stores/device/types'
import { defineStore } from 'pinia'

import { isSSR } from '@fond-of/env'

const screensBrandMap = {
  affenzahn: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  satch: {
    xs: 320,
    sm: 640,
    md: 960,
    lg: 1280,
    xl: 1600,
    max: 1920,
  },
  ergobag: {
    xs: 481,
    sm: 641,
    md: 961,
    lg: 1160,
    xl: 1366,
  },
}

const screens = screensBrandMap[import.meta.env.PUBLIC_BRAND]

export const useDeviceStore = createClientSharedComposable(() =>
  defineStore('device', {
    state: (): DeviceStore => ({
      // TODO: remove if we only use ssr (removed checkout and self-service)
      currentDeviceType: isSSR()
        ? null
        : globalThis.screen.width >= screens.md
          ? 'desktop'
          : 'mobile',
    }),

    getters: {
      screens: () => {
        return screens
      },

      deviceType(): DeviceType {
        if (!this.currentDeviceType) {
          // This error usually occurs when translations are loaded initially.
          throw new Error('Device type needs to be set before using it.')
        }

        return this.currentDeviceType
      },

      screenWidthGuess(): number {
        if (this.deviceType === 'desktop') {
          return this.screens.lg
        }

        if (this.deviceType === 'tablet') {
          return this.screens.md
        }

        return this.screens.sm - 1
      },
    },

    actions: {
      setDeviceType(deviceType: DeviceType) {
        this.currentDeviceType = deviceType
      },
    },

    hydrate: (storeState) => {
      storeState.currentDeviceType =
        globalThis.screen.width >= screens.md ? 'desktop' : 'mobile'
    },
  })(getStore())
)
